module.exports = __webpack_public_path__ + "static/img/firework-02.4dca03d.png";